import type { MedalPhysicsSystem } from '../physics';
import type { PhysicsPerformanceSample } from './types';

/** Maps live medal telemetry without giving the governor ownership of physics. */
export function createMedalPhysicsPerformanceSource(
  physics: Pick<MedalPhysicsSystem, 'telemetry'>,
): () => PhysicsPerformanceSample {
  return () => {
    const telemetry = physics.telemetry;
    return {
      engine: telemetry.engine,
      activeItems: telemetry.total,
      activeCoins: telemetry.coins,
      activeCards: telemetry.cards,
      sleepingItems: telemetry.sleepingCoins + telemetry.sleepingCards,
      bodies: telemetry.worldBodies,
      colliders: telemetry.worldColliders,
      ccdBodies: telemetry.activeCcdCoins,
      fixedTimeStepSeconds: telemetry.fixedTimeStep,
      lastFrameFixedSteps: telemetry.lastFrameFixedSteps,
      droppedAccumulatorSeconds: telemetry.droppedAccumulatorSeconds,
      estimatedCoinDrawCalls: telemetry.estimatedCoinDrawCalls,
    };
  };
}
